module.exports = __webpack_public_path__ + "img/Inspection1.625ff60e.png";